module.exports = __webpack_public_path__ + "img/064382cb51c231f7d46e8d7800cbac09.png";